module.exports = __webpack_public_path__ + "img/组 23.771ba9c2.png";